    @if (draft && completion) {
      <div class="rounded-2xl border p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6"
        [ngClass]="shelvedDraft
          ? 'border-jungle-green/30 bg-jungle-green/8'
          : 'border-gold/40 bg-gold/8'">
        <!-- Icon + label -->
        <div class="flex items-start gap-3 md:flex-1 min-w-0">
          <span class="w-12 h-12 rounded-full inline-flex items-center justify-center shrink-0"
            [ngClass]="shelvedDraft ? 'bg-jungle-green/15 text-jungle-green' : 'bg-gold/25'"
            [style.color]="shelvedDraft ? null : '#8a5a00'">
            <span aria-hidden="true" class="material-symbols-outlined text-2xl" style="font-variation-settings: 'FILL' 1;">{{ shelvedDraft ? 'inventory_2' : 'drafts' }}</span>
          </span>
          <div class="flex-1 min-w-0">
            <div class="flex items-baseline gap-2 flex-wrap">
              <span class="text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold"
                [ngClass]="shelvedDraft ? 'text-jungle-green' : ''"
                [style.color]="shelvedDraft ? null : '#8a5a00'">
                {{ shelvedDraft ? 'Saved copy' : 'Draft in progress' }}
              </span>
              <span class="text-[0.65rem] font-body text-muted-text">· {{ updatedLabel }}</span>
              @if (shelvedDraft && isStale) {
                <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-dark-text/10 text-muted-text text-[0.55rem] uppercase tracking-[0.12em] font-button font-bold">
                  <span aria-hidden="true" class="material-symbols-outlined text-[10px]">history</span>
                  Stale
                </span>
              }
            </div>
            @if (editingTitle && shelvedDraft) {
              <input aria-label="Draft title" #titleInput type="text" [(ngModel)]="titleDraft" maxlength="80"
                (blur)="commitTitleEdit()"
                (keydown.enter)="commitTitleEdit()"
                (keydown.escape)="cancelTitleEdit()"
                class="mt-0.5 w-full font-headline font-bold text-dark-text text-lg md:text-xl leading-tight bg-white border border-jungle-green/40 rounded-md px-2 py-1 focus:outline-none focus:border-jungle-green">
            } @else {
              <h3 class="font-headline font-bold text-dark-text text-lg md:text-xl leading-tight mt-0.5 truncate"
                [class.cursor-text]="shelvedDraft"
                [attr.title]="shelvedDraft ? 'Click to rename' : null"
                (click)="startTitleEdit()">
                {{ draft.title || 'Untitled property' }}
              </h3>
            }
            @if (shelvedDraft && sourceTitle) {
              <div class="text-[0.65rem] font-body text-muted-text mt-1 flex items-center gap-1 min-w-0">
                <span aria-hidden="true" class="material-symbols-outlined text-[12px]">subdirectory_arrow_right</span>
                <span class="truncate">Copied from {{ sourceTitle }}</span>
              </div>
            }
            @if (shelvedDraft && isAncient) {
              <div class="mt-2 inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-dark-text/[0.04] text-muted-text text-[0.65rem] font-body">
                <span aria-hidden="true" class="material-symbols-outlined text-sm">schedule</span>
                Untouched for 60+ days — still need this copy?
                <button type="button" (click)="discard()"
                  class="text-trinidad font-button font-bold uppercase tracking-[0.1em] text-[0.6rem] hover:underline">
                  Discard
                </button>
              </div>
            }

            <!-- Progress bar -->
            <div class="mt-3 flex items-center gap-2.5">
              <div class="flex-1 h-1.5 bg-dark-text/10 rounded-full overflow-hidden max-w-xs">
                <div class="h-full bg-trinidad rounded-full transition-all duration-300"
                  [style.width.%]="completion.pct"></div>
              </div>
              <span class="text-[0.65rem] font-body font-bold text-dark-text shrink-0">
                {{ completion.stepsDone }} of {{ completion.stepsTotal }} steps · {{ completion.pct }}%
              </span>
            </div>

            <!-- Phase chips -->
            <div class="mt-2.5 flex items-center gap-1.5 flex-wrap">
              @for (done of completion.phasesDone; track $index) {
                <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[0.55rem] uppercase tracking-[0.12em] font-button font-bold"
                  [ngClass]="done
                    ? 'bg-jungle-green text-white'
                    : (currentPhase === $index + 1 ? 'bg-trinidad text-white' : 'bg-white border border-dark-text/15 text-muted-text')">
                  @if (done) {
                    <span aria-hidden="true" class="material-symbols-outlined text-[10px]" style="font-variation-settings: 'FILL' 1;">check</span>
                  }
                  Phase {{ $index + 1 }}
                </span>
              }
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-2 shrink-0 md:flex-col md:items-stretch md:gap-2">
          @if (shelvedDraft) {
            <button type="button" (click)="resume.emit()"
              class="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-jungle-green text-white text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 shadow-[0_6px_16px_rgba(41,93,66,0.25)] transition-opacity">
              Resume
              <span aria-hidden="true" class="material-symbols-outlined text-base">arrow_forward</span>
            </button>
          } @else {
            <a routerLink="/properties/new"
              class="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-trinidad text-white text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 shadow-[0_6px_16px_rgba(227,83,13,0.25)] transition-opacity no-underline">
              Continue
              <span aria-hidden="true" class="material-symbols-outlined text-base">arrow_forward</span>
            </a>
            <button type="button" (click)="duplicate.emit()"
              class="inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full bg-white border border-jungle-green/30 text-jungle-green text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold hover:bg-jungle-green/10 transition-colors">
              <span aria-hidden="true" class="material-symbols-outlined text-sm">content_copy</span>
              Save a copy
            </button>
          }
          <button type="button" (click)="discard()"
            class="inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full bg-white border border-trinidad/30 text-trinidad text-[0.6rem] uppercase tracking-[0.12em] font-button font-bold hover:bg-trinidad/10 transition-colors">
            <span aria-hidden="true" class="material-symbols-outlined text-sm">delete</span>
            Discard
          </button>
        </div>
      </div>
    }
